import BaseChart from './BaseChart';

/**
 * BoxPlot chart implementation using VChart
 */
class BoxPlotChart extends BaseChart {
  /**
   * Get chart specification for boxplot chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    // BoxPlot specific fields
    const categoryField = this.options.categoryField || 'category';
    const seriesField = this.options.seriesField;
    
    // BoxPlot value fields
    const minField = this.options.minField || 'min';
    const q1Field = this.options.q1Field || 'q1';
    const medianField = this.options.medianField || 'median';
    const q3Field = this.options.q3Field || 'q3';
    const maxField = this.options.maxField || 'max';
    
    return {
      type: 'boxPlot',
      data,
      categoryField,
      seriesField,
      minField,
      q1Field,
      medianField,
      q3Field,
      maxField,
      
      // BoxPlot specific styling
      boxPlot: {
        style: {
          fill: (datum, element) => {
            return element.attribute?.stroke;
          },
          fillOpacity: 0.3,
          ...this.options.boxPlotStyle
        },
        state: {
          hover: {
            fillOpacity: 0.5,
            lineWidth: 2
          },
          ...this.options.boxPlotState
        }
      },
      
      // Optional outlier points
      point: this.options.showOutliers ? {
        visible: true,
        style: {
          size: 4,
          fillOpacity: 0.7,
          stroke: '#fff',
          lineWidth: 1,
          ...this.options.outlierStyle
        }
      } : { visible: false },
      
      // Label configuration
      label: {
        visible: this.options.showLabels === true,
        position: this.options.labelPosition || 'top',
        style: {
          fontSize: 12,
          fontWeight: 'normal',
          ...this.options.labelStyle
        },
        formatter: this.options.labelFormatter
      },
      
      // Axes configuration
      axes: [
        {
          orient: 'bottom',
          type: 'band',
          ...this.options.xAxis
        },
        {
          orient: 'left',
          type: 'linear',
          grid: {
            visible: true,
            style: {
              stroke: '#E8E8E8',
              lineWidth: 1,
              lineDash: [4, 4],
              ...this.options.gridStyle
            }
          },
          ...this.options.yAxis
        }
      ],
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
}

export default BoxPlotChart; 